import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, Typography, IconButton, Button, InputBase } from '@mui/material';
import { MoreVert, Add, Search as SearchIcon, Clear } from '@mui/icons-material';
import CloseMorph from '../CloseMorph/CloseMorph';
import { useAuth } from '../../hooks/useAuth';
import { useProjects } from '../../hooks/useProjects';
import { OpalCard } from '../OpalCard/OpalCard';

const Header = ({ setOpen, open }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setProjects, projectsCopy } = useProjects();
  const [search, setSearch] = useState({ string: '' });
  const { isAuthenticated } = useAuth();

  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
    svg: {
      fill: theme.palette.primary.light,
    },
  }));

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    border: 'solid 1px #ccc',
    borderRadius: '10px',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      [theme.breakpoints.up('sm')]: {
        width: '15ch',
        '&:focus': {
          width: '23ch',
        },
      },
    },
  }));

  const pageTitleMappings = {
    '/': 'Dashboard',
    '/projects': 'Projects',
    '/project-edit': 'Project edit',
    '/pages': 'Pages',
    '/page-edit': 'Page edit',
    '/sliders': 'Site slider',
    '/blocks': 'Site blocks',
    '/site-settings': 'Site settings',
  };

  const debounce = (func, time) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), time);
    };
  };

  const handleSearch = debounce((query) => {
    console.log('query', query);
    if (query.length > 2) {
      const filteredProjects = projectsCopy.filter((project) => project.name.toLowerCase().includes(query.toLowerCase()));
      if (filteredProjects.length > 0) {
        setProjects(filteredProjects);
        setSearch({ string: query });
      } else {
        setSearch({ string: 'No projects found' });
        setProjects(projectsCopy);
      }
    }
  }, 1000);

  const clearSearch = () => {
    setSearch({ string: '' });
    setProjects(projectsCopy);
  };

  const projectsAction = (
    <>
      <OpalCard>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase onChange={(e) => handleSearch(e.target.value)} placeholder="Search project…" />
        </Search>
      </OpalCard>
      {search.string &&
        <Button
          variant="outlined"
          startIcon={<Clear />}
          onClick={clearSearch}
          sx={{
            marginRight: 1,
            marginLeft: 2,
            width: 'fit-content',
            textTransform: 'capitalize',
            borderColor: 'error.main',
            borderRadius: '10px',
            color: 'error.main',
            '&:hover': {
              bgcolor: alpha('#d32f2f', 0.08),
              borderColor: 'error.main',
            },
          }}
        >
          Clear search
        </Button>
      }
      <Button sx={{ marginLeft: 2, borderRadius: '10px' }} variant="contained" onClick={() => navigate('/project-edit', { state: { mode: 'create' } })}>
        <Add /> Project
      </Button>
    </>
  );

  const pagesAction = (
    <>
      <Button variant="contained" onClick={() => navigate('/page-edit', { state: { mode: 'create' } })}>
        <Add /> Page
      </Button>
    </>
  );


  const otherActions = (
    <IconButton aria-label="More" onClick={() => { }}>
      <MoreVert className="blue" fontSize="small" />
    </IconButton>
  );

  const actionMappings = {
    '/projects': projectsAction,
    '/project-edit': otherActions,
    '/pages': pagesAction
  };

  return (
    isAuthenticated && (
      <AppBar position="sticky" color="default" style={{ top: 0, borderRadius: '0.2rem', background: '#fff' }}>
        <Toolbar>
          <IconButton fontSize="small" onClick={() => setOpen(true)} style={{ marginLeft: -12, marginRight: 20 }} color="primary" aria-label="Menu">
            {isAuthenticated && <CloseMorph open={open} />}
          </IconButton>
          <Typography variant="h6" color="primary" style={{ flexGrow: 1 }}>
            {pageTitleMappings[location.pathname]}{search.string && ` : ${search.string}`}
          </Typography>
          {isAuthenticated && actionMappings[location.pathname]}
        </Toolbar>
      </AppBar >)
  );
};

Header.propTypes = {
  setOpen: PropTypes.func,
};

export default Header;
